import * as R from 'ramda';
import {select, call, put, takeEvery} from 'redux-saga/effects';
import {CRUD_UPDATE_SUCCESS, userLogout} from 'react-admin';
import {getUserId} from './selectors';
import actions from './actions';
import {dataProvider} from '../../App';
import * as baker from '../../misc/cookie';
import {newDataProvider} from '../../misc/dataProvider';


function updateUserProfile() {
    return dataProvider(actions.USER_LOAD_START, 'user')
        .then(({data}) => {
            const {user} = data;
            return Promise.resolve(user);
        })
        .catch(() => {
            return Promise.resolve(null);
        })
}


function* handleUserUpdate(action) {
    const resource = R.pathOr(null, ['meta', 'resource'], action);
    if (resource === 'staff') {
        const currentUserId = yield select(getUserId);
        const updatedId = R.pathOr(null, ['payload','data', 'id'], action);
        if (currentUserId === updatedId) {
            const userData = yield call(updateUserProfile);
            yield put(actions.updateUserProfile(userData));
        }
    }
}


function enhancedUpdateUserProfile(someDataProvider) {
    return () => someDataProvider(actions.USER_LOAD_START, 'user')
        .then(({data}) => {
            const {user} = data;
            return Promise.resolve(user);
        })
        .catch(() => {
            return Promise.resolve(null);
        })
}

function* startUserUpdate(action) {
    let token = baker.getCookie("spa_token");
    if (! token) {
        token = localStorage.getItem('token')
    }
    const updateUserProfileClb = token
        ? enhancedUpdateUserProfile(newDataProvider(token))
        : updateUserProfile;
    const userData = yield call(updateUserProfileClb);
    if (!userData) {
        yield put(userLogout());
    } else {
        yield put(actions.updateUserProfile(userData));
    }
}

export default function* userSaga() {
    yield takeEvery(CRUD_UPDATE_SUCCESS, handleUserUpdate);
    yield takeEvery(actions.USER_LOAD_FROM_APP_BAR, startUserUpdate);
}



